import React, { Component } from 'react';

class DropdownNestedContent extends Component {
  render() {
    const { links = [] } = this.props || {};
    if (links.length === 0) return null;

    return (
      <div
        className="dropdownNestedContent"
      >
        <div className="borderRoundTop" />
        <ul className="resetUlStyles dropdownContent">
          {
            links.map(({ text, url }) => (
              <li key={text}>
                <a
                  className="textIndentEfect"
                  href={url}
                >
                  {text}
                </a>
              </li>
            ))
          }
        </ul>
        <div className="borderRoundBottom" />
      </div>
    );
  }
}

export default DropdownNestedContent;
